import ExtensionService from "@/service/ExtensionService";

export const LUNCH_FOOD_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive"
};

export const LUNCH_CATEGORY_OPTIONS = [
  { code: "SAVORY", label: "Món mặn", imageKey: "chicken" },
  { code: "VEGETABLE", label: "Rau", imageKey: "vegetable" },
  { code: "SOUP", label: "Canh", imageKey: "soup" },
  { code: "DESSERT", label: "Tráng miệng", imageKey: "dessert" }
];

const foodImages = {
  chicken:
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 200'%3E%3Cdefs%3E%3ClinearGradient id='g' x1='0' x2='1' y1='0' y2='1'%3E%3Cstop stop-color='%23fff4e8'/%3E%3Cstop offset='1' stop-color='%23f8b66b'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='320' height='200' fill='url(%23g)'/%3E%3Cellipse cx='160' cy='124' rx='94' ry='44' fill='%23fff7ed'/%3E%3Ccircle cx='128' cy='98' r='35' fill='%23c76a21'/%3E%3Ccircle cx='177' cy='96' r='32' fill='%23de8538'/%3E%3Ccircle cx='205' cy='123' r='24' fill='%23b9561d'/%3E%3Cpath d='M76 63c45 17 105 15 166-2' fill='none' stroke='%232f855a' stroke-width='12' stroke-linecap='round'/%3E%3C/svg%3E",
  vegetable:
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 200'%3E%3Cdefs%3E%3ClinearGradient id='g' x1='0' x2='1' y1='0' y2='1'%3E%3Cstop stop-color='%23f0fdf4'/%3E%3Cstop offset='1' stop-color='%2386efac'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='320' height='200' fill='url(%23g)'/%3E%3Cellipse cx='160' cy='128' rx='99' ry='39' fill='%23fff7ed'/%3E%3Cpath d='M96 124c30-46 52-50 68-15 22-38 49-38 72 3-24 34-58 43-100 26-19 5-33 0-40-14z' fill='%2322c55e'/%3E%3Cpath d='M102 139c43-16 85-17 126-2' fill='none' stroke='%23166534' stroke-width='8' stroke-linecap='round'/%3E%3C/svg%3E",
  soup:
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 200'%3E%3Cdefs%3E%3ClinearGradient id='g' x1='0' x2='1' y1='0' y2='1'%3E%3Cstop stop-color='%23eff6ff'/%3E%3Cstop offset='1' stop-color='%23bfdbfe'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='320' height='200' fill='url(%23g)'/%3E%3Cellipse cx='160' cy='111' rx='91' ry='43' fill='%23fef3c7'/%3E%3Cpath d='M79 111c8 44 30 65 81 65s73-21 81-65z' fill='%23fff7ed'/%3E%3Ccircle cx='131' cy='104' r='12' fill='%23f59e0b'/%3E%3Ccircle cx='169' cy='96' r='10' fill='%2322c55e'/%3E%3Ccircle cx='194' cy='116' r='9' fill='%23fb923c'/%3E%3C/svg%3E",
  dessert:
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 200'%3E%3Cdefs%3E%3ClinearGradient id='g' x1='0' x2='1' y1='0' y2='1'%3E%3Cstop stop-color='%23fff7ed'/%3E%3Cstop offset='1' stop-color='%23fde68a'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='320' height='200' fill='url(%23g)'/%3E%3Cellipse cx='160' cy='129' rx='95' ry='38' fill='%23fff7ed'/%3E%3Ccircle cx='126' cy='102' r='28' fill='%23facc15'/%3E%3Ccircle cx='176' cy='94' r='30' fill='%23fb923c'/%3E%3Ccircle cx='207' cy='123' r='22' fill='%23f59e0b'/%3E%3Cpath d='M115 128c28 15 67 15 99 1' fill='none' stroke='%23a16207' stroke-width='8' stroke-linecap='round'/%3E%3C/svg%3E"
};

export function setDefaultFoodImages(images = {}) {
  LUNCH_CATEGORY_OPTIONS.forEach((option) => {
    const image = images[option.code];
    if (image) {
      const value = String(image);
      foodImages[option.imageKey] = /^[a-f\d]{24}$/i.test(value)
        ? `${ExtensionService.urlDowloadFile}${value}`
        : value;
    }
  });
}

export function getCategoryLabel(category) {
  const option = LUNCH_CATEGORY_OPTIONS.find((item) => item.code === category || item.label === category);
  return option ? option.label : category || "";
}

export function getCategoryCode(category) {
  const option = LUNCH_CATEGORY_OPTIONS.find((item) => item.code === category || item.label === category);
  return option ? option.code : category || "";
}

export function getDefaultFoodImage(category) {
  const code = getCategoryCode(category);
  const option = LUNCH_CATEGORY_OPTIONS.find((item) => item.code === code) || LUNCH_CATEGORY_OPTIONS[0];
  return foodImages[option.imageKey];
}
